module.exports = __webpack_public_path__ + "img/whiteLogo.46f8854d.svg";